// [전체 코드 미사용/주석 삭제 금지]

// Base imports
import React from 'react';
import {useNavigate} from 'react-router-dom';

// Images import
import ArrowLeft from "assets/images/icon/arrow-left-icon.svg";

// CSS import
import 'styles/Font.css';

// 상단 네비게이션 바 컴포넌트
function TopNavigator({title, isTransparent = false}) {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // 뒤로가기
    };

    return (
        <div style={{...staticStyles.topNavigatorArea, backgroundColor: isTransparent ? 'transparent' : '#0D042D',}}>
            <nav style={staticStyles.topNavigatorContainer}>
                {/* back-button에 있던 인라인 스타일과 CSS cursor: pointer를 staticStyles.backButton으로 통합하여 적용 */}
                <div
                    onClick={handleGoBack}
                    style={staticStyles.backButton}
                >
                    <img
                        src={ArrowLeft}
                        alt="뒤로가기"
                        style={staticStyles.backArrow}
                    />
                </div>
                {/* page-title 스타일 적용 */}
                {title && <span style={staticStyles.pageTitle}>{title}</span>}
            </nav>
        </div>
    );
}

// [!! staticStyles 객체 추가 !!]
/** @type {React.CSSProperties} */
const staticStyles = {
    // .top-navigator-area
    topNavigatorArea: {
        width: '100%',
        boxSizing: 'border-box',
        flexShrink: 0,

        // sticky 속성 추가
        position: 'sticky',
        top: 0,
        zIndex: 1000, // 다른 요소들 위에 있도록 z-index 추가
        backgroundColor: '#0D042D',

        // 안전 영역(env) + 기본 여백(12px)
        paddingTop: 'max(env(safe-area-inset-top), 60px)',
        paddingLeft: '24px',
        paddingRight: '24px',
        paddingBottom: '10px',
    },
    // .top-navigator-container
    topNavigatorContainer: {
        display: 'flex',
        justifyContent: 'center', // 제목을 중앙으로
        alignItems: 'center',
        position: 'relative',
        width: '100%',
        height: '24px',
    },

    backButton: {
        width: '24px',
        height: '24px',
        cursor: 'pointer',
        position: 'absolute',
        left: 0,
        // 세로 중앙 정렬
        top: '50%',
        transform: 'translateY(-50%)',
        // 이미지 중앙 정렬을 위해 flex 적용 (TopNavigatorContainer의 align-items: center 대신)
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    // .back-arrow (img tag)
    // 크기만 지정하며, 포지셔닝은 부모인 backButton이 담당
    backArrow: {
        width: '7px',
        height: '14px',
        // 원본 CSS에 있던 border: 2px는 유효하지 않은 속성으로 판단하여 제거했습니다.
    },

    // .page-title
    pageTitle: {
        fontFamily: '"Pretendard", sans-serif',
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '17px',
        letterSpacing: '0px',
        textAlign: 'center',
        verticalAlign: 'middle',
        color: '#FCFCFA',
        margin: '0 auto',
    },
};

export default TopNavigator;